var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { setWidgetsFromDashboards } from './widgets';
import { setAllDashboardWidgets } from './dashboardWidgets';
const initialState = {
    loading: true,
    saveLayoutLoading: false,
    data: [],
    dashboardWidgetsData: {},
    error: null,
};
// dashboards
export const fetchAllDashboards = createAsyncThunk('dashboards/fetchAll', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const res = yield api.dashboards.fetchAll();
        const widgetsInst = res.results.flatMap((dashboard) => dashboard.widgetsInst);
        const dashboardWidgets = res.results.flatMap((dashboard) => dashboard.rel_dashboardWidgetInst);
        dispatch(setWidgetsFromDashboards(widgetsInst));
        dispatch(setAllDashboardWidgets(dashboardWidgets));
        return fulfillWithValue(res.results);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchOneDashboard = createAsyncThunk('dashboards/fetchOne', (dashboardId_1, _a) => __awaiter(void 0, [dashboardId_1, _a], void 0, function* (dashboardId, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const res = yield api.dashboards.fetchOne(dashboardId);
        const widgetsInst = res.widgetsInst;
        const dashboardWidgets = res.rel_dashboardWidgetInst;
        dispatch(setWidgetsFromDashboards(widgetsInst));
        dispatch(setAllDashboardWidgets(dashboardWidgets));
        return fulfillWithValue(res.results);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const createDashboard = createAsyncThunk('dashboards/create', (dashboard_1, _a) => __awaiter(void 0, [dashboard_1, _a], void 0, function* (dashboard, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.dashboards.create(dashboard);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateDashboard = createAsyncThunk('dashboards/update', (updatedDashboard_1, _a) => __awaiter(void 0, [updatedDashboard_1, _a], void 0, function* (updatedDashboard, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.dashboards.update(Object.assign({}, updatedDashboard));
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const deleteDashboard = createAsyncThunk('dashboards/delete', (dashboardId_1, _a) => __awaiter(void 0, [dashboardId_1, _a], void 0, function* (dashboardId, { fulfillWithValue, rejectWithValue }) {
    try {
        yield api.dashboards.delete(dashboardId);
        return fulfillWithValue(dashboardId);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
// dashboard data
export const fetchDashboardData = createAsyncThunk('dashboards/data/fetchOne', (id_1, _a) => __awaiter(void 0, [id_1, _a], void 0, function* (id, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.dashboards.datas({ id });
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const { reducer } = createSlice({
    name: 'dashboards',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // FETCH ALL DASHBOARDS
        builder.addCase(fetchAllDashboards.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchAllDashboards.fulfilled, (state, { payload }) => {
            state.data = payload;
            state.loading = false;
        });
        builder.addCase(fetchAllDashboards.rejected, (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        });
        // FETCH DASHBOARD WIDGETS DATA
        builder.addCase(fetchDashboardData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchDashboardData.fulfilled, (state, { payload }) => {
            state.dashboardWidgetsData = payload;
            state.loading = false;
        });
        builder.addCase(fetchDashboardData.rejected, (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        });
        // CREATE DASHBOARD
        builder.addCase(createDashboard.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createDashboard.fulfilled, (state, { payload }) => {
            state.data = [...state.data, payload];
            state.loading = false;
        });
        builder.addCase(createDashboard.rejected, (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        });
        // UPDATE DASHBOARD
        builder.addCase(updateDashboard.pending, (state) => {
            state.saveLayoutLoading = true;
        });
        builder.addCase(updateDashboard.fulfilled, (state, { payload }) => {
            const newDashboards = state.data.map((dashboard) => {
                if (dashboard.id === payload.id) {
                    return payload;
                }
                return dashboard;
            });
            state.data = newDashboards;
            state.saveLayoutLoading = false;
        });
        builder.addCase(updateDashboard.rejected, (state, { payload }) => {
            state.error = payload;
            state.saveLayoutLoading = false;
        });
        // DELETE DASHBOARD
        builder.addCase(deleteDashboard.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteDashboard.fulfilled, (state, { payload }) => {
            state.data = state.data.filter((dashboard) => dashboard.id !== payload);
            state.loading = false;
        });
        builder.addCase(deleteDashboard.rejected, (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        });
    },
});
export default reducer;
